<script lang="ts" setup>
import PopUp from '#components/popUp/PopUp.vue';
import { useLanguage } from '#composables/useLanguage';
import PeriodSelector from '#domain/core/filter/components/periodSelector/PeriodSelector.vue';
import type {
  CarrefourReferentialIntervalType,
  ComparisonPeriodType,
  DatePeriodIntervalType,
  NielsenPeriodIntervalType,
  ProductTaxonomyType,
  ReferentialIntervalsType
} from '@carrefour-gcs/shared';
import type { AvailablePeriodType } from './periodSelector/types/availablePeriod.type';

const { t } = useLanguage();

defineProps<{
  show: boolean;
  taxonomy: ProductTaxonomyType;
  selectedPeriod: DatePeriodIntervalType | NielsenPeriodIntervalType;
  comparisonPeriod: ComparisonPeriodType;
  hasComparisonPeriod: boolean;
  referentialIntervals: ReferentialIntervalsType;
  carrefourReferentialIntervals: keyof CarrefourReferentialIntervalType;
  availablePeriods: AvailablePeriodType[];
  isDefaultValues: boolean;
}>();

const emit = defineEmits<{
  onSelectPeriod: [period: DatePeriodIntervalType | NielsenPeriodIntervalType, comparisonPeriod?: ComparisonPeriodType];
  onClose: [];
}>();
</script>
<template>
  <PopUp :title="t('timeSelectorPopin.title')" :open="show" @on-close="emit('onClose')">
    <PeriodSelector
      :taxonomy="taxonomy"
      :referential-intervals="referentialIntervals"
      :carrefour-referential-intervals="carrefourReferentialIntervals"
      :available-periods="availablePeriods"
      :selected-period="selectedPeriod"
      :comparison-period="comparisonPeriod"
      :has-comparison-period="hasComparisonPeriod"
      :is-default-values="isDefaultValues"
      @change="emit('onSelectPeriod', $event.period, $event.comparisonPeriod)"
      @on-close="emit('onClose')"
    />
  </PopUp>
</template>
